import React, { useMemo } from "react";
import "../NepaliDatePicker.css";
import { ConfigProvider } from "./Config";
import NepaliDatePicker from "./NepaliDatePicker";
import {
  ENGLISH,
  INepaliDatePicker,
  NEPALI,
  NepaliDatePickerProps,
} from "./Types";

const NepaliDatePickerWrapper: React.FC<NepaliDatePickerProps> = ({
  className = "",
  inputClassName = "",
  value = "",
  onChange = () => null,
  onSelect = () => null,
  options = {},
  todayIfEmpty = false,
  maxYear,
  minYear,
  isOpen,
  disableFuture,
  setIsOpen,
  ...rest
}) => {
  const calenderOptions = useMemo(
    () => ({
      closeOnSelect: true,
      calenderLocale: NEPALI,
      valueLocale: ENGLISH,
      ...options,
    }),
    [options]
  );

  return (
    <ConfigProvider maxYear={maxYear} minYear={minYear}>
      <NepaliDatePicker
        {...({
          ...rest,
          className,
          inputClassName,
          value,
          onChange,
          onSelect,
          options: calenderOptions,
          todayIfEmpty,
          isOpen,
          disableFuture,
          setIsOpen,
        } as INepaliDatePicker)}
      />
    </ConfigProvider>
  );
};

export default NepaliDatePickerWrapper;
